<template>
  <div
    class="trezo-card bg-purple-700 mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content text-center">
      <h3 class="text-[20px] md:text-xl mb-[9px] text-white font-semibold">
        Schedule Appointment
      </h3>
      <p class="mx-auto max-w-[275px] leading-[1.6] mb-[25px] text-white">
        Quickly schedule an appointment for a patient with any available doctor.
      </p>
      <img
        src="@/assets/images/doctor.png"
        alt="doctor-image"
        class="d-block mx-auto"
      />
      <a
        href="javascript:void(0);"
        class="inline-block bg-primary-500 text-white rounded-md md:text-md mt-[25px] py-[6px] px-[17px] font-medium transition-all hover:bg-primary-600"
      >
        Book Appointment
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ScheduleAppointment",
});
</script>
